<template>
  <Teleport to="body">
    <div id="remove_participant_modal" class="modal fade" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                    <h4 class="modal-title">DELETE {{ participantSingularName.toUpperCase() }}</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <p>Enter your password to confirm the deletion of this {{ participantSingularName.toLowerCase() }}.</p>
                            <p style="font-weight:bold">NOTE: Clicking OK will permanently delete the {{participantSingularName.toLowerCase() }}.</p>
                            <form autocomplete="off">
                              <input id="remove-participant-password"
                                     type="password"
                                     class="form-control"
                                     v-validate="'required'"
                                     v-model="userPassword">
                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn green mt-ladda-btn ladda-button remove-participant-control" data-dismiss="modal"
                            data-style="expand-left"
                            @click.prevent="doRemoveParticipant()">
                        <span class="ladda-label">OK</span>
                    </button>
                    <button class="btn default" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
  </Teleport>
</template>

<script>
    import {mapActions} from 'vuex';
    import Teleport from 'vue2-teleport';
    import participantDisplayName from '@/mixins/participantDisplayName';

    export default {
        name: 'RemoveParticipantModal',
        components: {Teleport},
        props: ['show', 'participantId'],
        mixins: [
          participantDisplayName
        ],
        data() {
            return {
                userPassword: ''
            }
        },
        methods: {
            ...mapActions({
                removeParticipant: 'REMOVE_PARTICIPANT_ACTION',
            }),
            doRemoveParticipant() {
                let pass = this.userPassword;
                this.userPassword = '';
                this.removeParticipant({id: this.$route.params.id, context: '', password: pass});
            }
        },
        mounted() {
          $('#remove_participant_modal')
            .on('hidden.bs.modal', () => {
              this.userPassword = '';
            }).on('show.bs.modal', () => {
              this.userPassword = '';
            });
        },
    }
</script>



// WEBPACK FOOTER //
// RemoveParticipantModal.vue?e673a0f2